import React, { useState, useEffect } from 'react';
import _ from 'lodash';
import {
  Divider,
  Grid,
  Header,
  Segment,
  Table,
  Input
} from 'semantic-ui-react';
import { servicesAPI } from '../../_services';
// import { history } from '../../_helpers/';
import { copyToClipboard } from '../../utils';

export const ListLocalAuthorities = () => {
  const [localAuthorities, setLocalAuthorities] = useState([]);
  const [localAuthorityFilter, setLocalAuthorityFilter] = useState('');
  const [postcodeFilter, setPostcodeFilter] = useState('');
  const [sortColumn, setSortColumn] = useState(null);
  const [sortDirection, setSortDirection] = useState('asc');
  const [sortLabel, setSortLabel] = useState('ascending');
  const [sortedData, setSortedData] = useState([]);

  const sortTable = column => {
    setSortColumn(column);
    setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc');
    setSortLabel(sortLabel === 'ascending' ? 'descending' : 'ascending');
  };

  useEffect(() => {
    async function getLocalAuthorities() {
      try {
        const localAuthorities = await servicesAPI.AdminServices(
          'getLocalAuthoritiesPostcodes'
        );

        setLocalAuthorities(
          localAuthorities
            ? _.orderBy(localAuthorities, 'description').filter(
                ({ tag_status }) => tag_status !== 'INACTIVE'
              )
            : []
        );
      } catch (error) {}
    }

    getLocalAuthorities();

    sortTable('name');
    const sortDir = 'asc';
    setSortDirection(sortDir);
    setSortLabel(sortDir === 'asc' ? 'descending' : 'ascending');
  }, []);

  useEffect(() => {
    if (localAuthorities.length === 0) return;

    const sorted =
      sortColumn && sortDirection
        ? _.orderBy(localAuthorities, sortColumn, sortDirection)
        : localAuthorities;

    setSortedData(
      sorted
        .filter(
          ({ name }) =>
            !localAuthorityFilter ||
            (name &&
              name.toLowerCase().includes(localAuthorityFilter.toLowerCase()))
        )
        .filter(
          ({ approved_postcodes }) =>
            !postcodeFilter ||
            (approved_postcodes &&
              approved_postcodes
                .toLowerCase()
                .includes(postcodeFilter.toLowerCase()))
        )
        .filter(
          ({ unapproved_postcodes }) =>
            !postcodeFilter ||
            (unapproved_postcodes &&
              unapproved_postcodes
                .toLowerCase()
                .includes(postcodeFilter.toLowerCase()))
        )
    );
  }, [localAuthorities, localAuthorityFilter, sortColumn, sortDirection]);

  return (
    <Segment>
      <Grid stretched>
        <Grid.Row>
          <Grid.Column>
            <Header as="h2">Trojan Home Postcode Approval</Header>
          </Grid.Column>
          <Grid.Column
            floated="right"
            textAlign="right"
            mobile={6}
            tablet={4}
            computer={3}
          />
        </Grid.Row>
      </Grid>
      <Divider hidden />
      <Grid>
        <Grid.Row>
          <Grid.Column>
            <Input
              type="text"
              placeholder="filter local authority"
              icon={{
                name: 'close',
                link: true,
                onClick: () => {
                  setLocalAuthorityFilter('');
                }
              }}
              value={localAuthorityFilter}
              onChange={(event, { value }) => {
                setLocalAuthorityFilter(value);
              }}
            />
            {'   '}
            <Input
              type="text"
              placeholder="filter postcode"
              icon={{
                name: 'close',
                link: true,
                onClick: () => {
                  setPostcodeFilter('');
                }
              }}
              value={postcodeFilter}
              onChange={(event, { value }) => {
                setPostcodeFilter(value);
              }}
            />
          </Grid.Column>
        </Grid.Row>
        <Table sortable celled fixed>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell
                sorted={sortColumn === 'name' ? sortLabel : null}
                onClick={() => sortTable('name')}
                style={{ width: '100px' }}
              >
                Local
                <br />
                Authority
              </Table.HeaderCell>
              <Table.HeaderCell style={{ width: '120px' }}>
                Approved
                <br />
                Postcodes
              </Table.HeaderCell>
              <Table.HeaderCell style={{ width: '300px' }}>
                Non-Approved
                <br />
                Postcodes
              </Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {sortedData.map((la, la_idx) => (
              <Table.Row key={la_idx}>
                <Table.Cell
                  onClick={() => {
                    copyToClipboard(la.name);
                  }}
                >
                  {la.name}
                </Table.Cell>
                <Table.Cell
                  onClick={() => {
                    // history.push(`/admin/hubs/${h.hydra_aon.reference}`);
                  }}
                >
                  {la.approved_postcodes}
                </Table.Cell>
                <Table.Cell
                  onClick={() => {
                    // history.push(`/admin/hubs/${h.hydra_aon.reference}`);
                  }}
                >
                  {la.unapproved_postcodes}
                </Table.Cell>
              </Table.Row>
            ))}
          </Table.Body>
        </Table>
      </Grid>
    </Segment>
  );
};
